module.exports = __webpack_public_path__ + "img/Zircly_Logo.bf594ab7.svg";